import { Card, Form, Input } from 'antd';
import { EditLayout } from 'components/layout/layout/EditLayout';
import { IInteractiveClass } from 'interfaces/interactive_classes';
import { PageHeader } from 'components/professor_area/PageHeader';
import { PlaySquareOutlined } from '@ant-design/icons';
import { useCan } from '@refinedev/core';
import { useForm } from '@refinedev/antd';

export const InteractiveClassEdit = () => {
  const { data: canEdit } = useCan({
    resource: 'interactive_classes',
    action: 'edit'
  });
  const hasEditPermission = !!canEdit?.can;

  const { formProps, saveButtonProps, queryResult } =
    useForm<IInteractiveClass>({
      queryOptions: {
        enabled: hasEditPermission
      },
      redirect: 'edit'
    });

  const result = queryResult?.data?.data;

  if (!hasEditPermission) {
    return null;
  }

  return (
    <EditLayout saveButtonProps={saveButtonProps} title="Editar aula">
      <PageHeader title={result?.title} icon={PlaySquareOutlined} />

      <Card>
        <Form {...formProps} layout="vertical">
          <Form.Item
            name="title"
            label="Título da aula"
            rules={[
              { required: true, message: 'O título da aula é obrigatório' }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="description" label="Descrição">
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Card>
    </EditLayout>
  );
};
